const PaymentMethod = {
    IFRAME: 'iframe',
    HAFAKULTA: 'hafakulta'
};

const PaymentMethodOptions = [
    {
        text: 'Jerusalem ירושלים',
        value: PaymentMethod.IFRAME
    },
    {
        text: 'Rehovot רחובות',
        value: PaymentMethod.HAFAKULTA
    }
];

module.exports = {
    PaymentMethod,
    PaymentMethodOptions
};
